export default __webpack_public_path__ + "static/media/24.88fd6fae.jpg";